module.exports = __webpack_public_path__ + "img/check-circle.f9a03d3d.svg";